import { ApiV1Response, http } from 'api/v1/http'
import axios from 'axios'
import { ZKEX_API_BASE_URL } from 'config'
import { Address } from 'types'
export interface AirdropItem {
  id: number
  address: Address
  title: string
  type: number
  reward: number
  isLocked: boolean
  createdAt: number
}
export async function getAirdrops<T extends ApiV1Response<AirdropItem[]>>(
  address: Address,
): Promise<T> {
  const r = await axios.get<T>(`/users/airdrops/${address}`, {
    baseURL: ZKEX_API_BASE_URL,
  })
  return r.data
}
